import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ControllersContextTypes, ControllersProviderProps } from './types';

import { ControllersService } from 'src/services/controllers/controllers.service';
import { Controller } from 'src/types/controllers/controller';

const ControllersContext = React.createContext<ControllersContextTypes>(
  {} as ControllersContextTypes
);

export const useControllersContext = () => useContext(ControllersContext);

export const ControllersProvider = ({ children, customerId, siteId }: ControllersProviderProps) => {
  const [controllers, setControllers] = useState<Controller[]>([]);

  const getControllers = useCallback(() => {
    if (!customerId || !siteId) return;
    ControllersService.getAll(customerId, siteId).then((response) => {
      setControllers(response);
    });
  }, [customerId, siteId]);

  useEffect(() => {
    getControllers();
  }, [getControllers]);

  return (
    <ControllersContext.Provider value={{ controllers, getControllers }}>
      {children}
    </ControllersContext.Provider>
  );
};
